import { filePen, home, lock, tick, users } from "@simplybusiness/icons";
import { Icon, Text, type IconDefinition } from "@simplybusiness/mobius";

type SummaryProps = {
  header: string;
  isCollapsed: boolean;
};

const headerIconsMap = {
  "about your property": home,
  security: lock,
  "property use": users,
  "financial and claims": filePen,
} as const;

const headerTitlesMap = {
  "about your property": "Property information section",
  security: "Security information section",
  "property use": "Property usage section",
  "financial and claims": "Financial and claims section",
} as const satisfies Record<keyof typeof headerIconsMap, string>;

// Helper to get icon with proper typing
const getHeaderIcon = (header: string): IconDefinition => {
  const key = header.toLowerCase() as keyof typeof headerIconsMap;
  return headerIconsMap[key] || home;
};

// Helper to get title with proper typing
const getHeaderTitle = (header: string): string => {
  const key = header.toLowerCase() as keyof typeof headerTitlesMap;
  return headerTitlesMap[key] ?? "Information section";
};

export const Summary = ({ header, isCollapsed }: SummaryProps) => {
  return (
    <summary
      className="mobius-collapsible__summary"
      onClick={e => e.preventDefault()}
      tabIndex={-1}
    >
      <div className="mobius-collapsible__summary-content">
        {isCollapsed ? (
          <Icon
            data-testid="tick-icon"
            icon={tick}
            size="md"
            title="Section confirmed"
          />
        ) : (
          <Icon
            data-testid="header-icon"
            className="mobius-collapsible__summary-header-icon"
            icon={getHeaderIcon(header)}
            size="md"
            title={getHeaderTitle(header)}
          />
        )}
        <Text elementType="h2">{header}</Text>
      </div>
    </summary>
  );
};
